import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function EditUser(props) {
    const { t } = useTranslation();
    const first_name = useRef();
    const last_name = useRef();
    const email = useRef();
    const password = useRef();
    const username = useRef();
    const address = useRef();
    const phone = useRef();
    const notes = useRef();
    const collection_center_id = useRef();
    const role_id = useRef();

    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);
    const [user, setUser] = useState({});
    const id = props.match.params.id;
    const [collectionCenters, setCollectionCenters] = useState([]);
    const [roles, setRoles] = useState([]);
    const [fieldCenter, setFieldsCenters] = useState({
        'collection_center_id' : ''
    })
    const [fieldRole, setFieldsRole] = useState({
        'role_id' : ''
    })

    useEffect(() => {
        axios.get(API_URL + 'user/'+ id).then((response) => {

            if (response.data.status) {
                setUser(response.data.data);
                setFieldsRole({role_id: response.data.data.role_id});
                setFieldsCenters({collection_center_id: response.data.data.collection_center_id});
            } else if (response.data.code === 404) {
                alertify.error(response.data.message);
                return null;
            }
        });
    }, []);

    useEffect(() => {
        axios.get(API_URL + 'collection-center').then((response) => {

            if (response.data.status) {
                setCollectionCenters(response.data.data);
            } else if (response.data.code === 404) {
                alertify.error(response.data.message);
                return null;
            }
        });
    }, []);

    useEffect(() => {
        axios.get(API_URL + 'role').then((response) => {

            if (response.data.status) {
                setRoles(response.data.data);
            } else if (response.data.code === 404) {
                alertify.error(response.data.message);
                return null;
            }
        });
    }, []);



    const updateUserHandler = (e) => {
        e.preventDefault();
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + "user/update",
            {
                id: user.id,
                first_name: first_name.current.value,
                last_name: last_name.current.value,
                email: email.current.value,
                password: password.current.value,
                username: username.current.value,
                address: address.current.value,
                phone: phone.current.value,
                notes: notes.current.value,
                collection_center_id: collection_center_id.current.value,
                role_id: role_id.current.value,
            }
        ).then((response) => {
            setDisabled(0);
            setIconDisabled(1);
            if (response.data.status) {
                alertify.success(response.data.message);

                props.history.push("/user/list");
            } else {
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            if (error.message === 'Request failed with status code 401') {
                //props.logout();
            }
        });
    }

    const handlecenterChange = (e) => {
        setFieldsCenters({
            collection_center_id: e.target.value
        });
    }
    const handleroleChange = (e) => {
        setFieldsRole({
            role_id: e.target.value
        });
    }


    return (
        <Row>
            <Col md={12}>
                <Card>
                    <CardHeader title={t("Edit User")}>
                        <CardHeaderToolbar>
                            <Link to="/user/list" className="btn btn-primary btn-sm mx-3">
                                {t("User List")}
                            </Link>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>

                        <div className="mt-5">
                            <Form onSubmit={updateUserHandler}>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("First Name")}</Form.Label>
                                        <Form.Control ref={first_name} placeholder={t("Enter First Name")}
                                                      defaultValue={user.first_name}/>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Last Name")}</Form.Label>
                                        <Form.Control ref={last_name} rows={1} placeholder={t("Enter Last Name")}
                                                      defaultValue={user.last_name}/>
                                    </Form.Group>

                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Collection Centers")}</Form.Label>
                                        <Form.Control as="select" ref={collection_center_id} value={fieldCenter.collection_center_id} onChange={handlecenterChange}>
                                            {collectionCenters.map((collectionCenters, key) => (
                                                <option key={collectionCenters.id} value={collectionCenters.id}>
                                                    {collectionCenters.name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Role")}</Form.Label>
                                        <Form.Control as="select" ref={role_id} value={fieldRole.role_id} onChange={handleroleChange}>
                                            {roles.map((role, key) => (
                                                <option key={role.id} value={role.id}>
                                                    {role.name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Email")}</Form.Label>
                                        <Form.Control ref={email} placeholder={t("Enter Email")}
                                                      defaultValue={user.email}/>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Phone")}</Form.Label>
                                        <Form.Control ref={phone} rows={1} placeholder={t("Enter Phone")}
                                                      defaultValue={user.phone}/>
                                    </Form.Group>


                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("User Name")}</Form.Label>
                                        <Form.Control ref={username} rows={1} placeholder={t("Enter User Name")}
                                                      defaultValue={user.username}/>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Password")}</Form.Label>
                                        <Form.Control type={'password'} ref={password} rows={1} placeholder={t("Enter Password")}
                                                      defaultValue={user.password}/>
                                    </Form.Group>

                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Address")}</Form.Label>
                                        <Form.Control ref={address} rows={1} placeholder={t("Enter Address")}
                                                      defaultValue={user.address}/>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>{t("Notes")}</Form.Label>
                                        <Form.Control ref={notes} rows={1} placeholder={t("Enter Notes")}
                                                      defaultValue={user.notes}/>
                                    </Form.Group>
                                </Form.Row>

                                <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                    {t("Save")}
                                    <span
                                        dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                </Button>
                            </Form>

                        </div>

                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}